import axios from 'axios';

export default class PatientService {
    invitePatient(patientId) {
        return axios.post(`/v2/mobile-app/${patientId}/invite`);
    }
    updatePrescriptions(patientId, enabled, prescriptions) {
        return axios.put(`/v2/mobile-app/${patientId}/prescriptions`, {enabled, prescriptions});
    }
}
